import React from 'react';
import {observer} from 'mobx-react';
import {t} from 'shared/core';
import FilterComponent from 'main/components/tables/interactive/components/fancy_filter/filter_selector/FilterComponent';

const ExpenseRequestStatus = observer(({filter, filterKey, filterUpdated, filterDeleted, Wrapper}) => {
  const options = [
    { label: t('components.tables.fancy_filters.selectors.Pending'), value: 'pending' },
    { label: t('components.tables.fancy_filters.selectors.Approved'), value: 'approved' },
    { label: t('components.tables.fancy_filters.selectors.Rejected'), value: 'rejected' }
  ];

  return <FilterComponent filter={filter} filterKey={filterKey} options={options} filterUpdated={filterUpdated} filterDeleted={filterDeleted} Wrapper={Wrapper}/>;
});

export default ExpenseRequestStatus;
